import React from "react";
import { CheckIcon } from "@heroicons/react/24/solid";

const Tarif = () => {
  return (
    <div className="min-h-screen  py-12 px-4 sm:px-6 lg:px-24">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        <h1 className="text-3xl font-bold text-center mb-8 text-[#674DA2]">
          Ustaz Kids платформасының тарифтері
        </h1>
        <div className="flex flex-col lg:flex-row gap-8  w-full  ">
          {/* Left Card - Жеке тәрбиеші */}
          <div className="flex flex-col bg-white rounded-2xl shadow-lg p-8 w-full lg:w-1/3">
            <h2 className="text-2xl font-bold mb-2 text-[#2D2D2D]">
              Жеке тәрбиеші
            </h2>
            <p className="text-gray-500 mb-6">Жылдық тариф</p>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <CheckIcon className="w-5 h-5 text-[#674da2] mr-2 flex-shrink-0 mt-1" />
                <span>Тоғыз айға перспективалық жоспар</span>
              </li>
              <li className="flex items-start">
                <CheckIcon className="w-5 h-5 text-[#674da2] mr-2 flex-shrink-0 mt-1" />
                <span>Тоғыз айға циклограмма</span>
              </li>
              <li className="flex items-start">
                <CheckIcon className="w-5 h-5 text-[#674da2] mr-2 flex-shrink-0 mt-1" />
                <span>Үйлестірілген оқу іс-әрекеті кестесі</span>
              </li>
              <li className="flex items-start">
                <CheckIcon className="w-5 h-5 text-[#674da2] mr-2 flex-shrink-0 mt-1" />
                <span>Күн тәртібі</span>
              </li>
              <li className="flex items-start">
                <CheckIcon className="w-5 h-5 text-[#674da2] mr-2 flex-shrink-0 mt-1" />
                <span>Жаздық сауықтыру жоспары</span>
              </li>
            </ul>
            <a
              href="https://wa.me/+77776655965"
              className="bg-[#f9f2ff] text-[#674da2] cursor-pointer hover:bg-[#efe6f6] transition  rounded-full px-6 py-3 mt-4 md:mt-auto w-auto lg:w-auto self-start"
            >
              Жоспарды таңдау (30 000 ₸)
            </a>
          </div>

          {/* Right Card - Балабақша */}
          <div className="flex flex-col bg-[#674DA2] rounded-2xl shadow-lg p-8 w-full lg:w-2/3 text-white">
            <h2 className="text-2xl font-bold mb-2">Балабақша</h2>
            <p className="opacity-80 mb-6">Жылдық тариф</p>
            <div className="flex flex-col md:flex-row gap-8 flex-grow">
              {/* Column 1 - Тәрбиеші құжаттары */}
              <div className="flex flex-col space-y-3 w-full md:w-1/3">
                <h3 className="font-bold">Тәрбиеші құжаттары:</h3>
                <ul className="space-y-4 text-sm">
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Перспективалық жоспар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Циклограмма</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Баланың даму динамикасы</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Үйлестірілген оқу іс-әрекеті кестесі</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Ата-аналармен байланыс құралы</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Ертегілер (әр жас ерекшелігі бойынша)</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>
                      Құндылық іс-шаралары (Ата-аналармен, балалармен)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>
                      Педагогтердің жеке дамуына арналған кітаптар тізімі
                    </span>
                  </li>
                </ul>
              </div>

              {/* Column 2 - Видео материалдар */}
              <div className="flex flex-col space-y-3 w-full md:w-1/3">
                <h3 className="font-bold">Видео материалдар:</h3>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Топтың жабдықталуы фотолар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Еркін ойын уақыты видеолар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Ойындар видеолар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Ерте даму жаттығулары (маc) видеолар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Логопедиялық жаттығулар видеолар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>
                      Заттық кеңістік ортаны құрудың негізгі қағидалары
                    </span>
                  </li>
                </ul>
              </div>

              {/* Column 3 - Әдіскердің құжаттары */}
              <div className="flex flex-col space-y-3 w-full md:w-1/3">
                <h3 className="font-bold">Әдіскердің құжаттары:</h3>
                <p className="font-semibold opacity-80">Құжаттар:</p>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Нұсқаулық хаттар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Еңбек әрекеті кезіндегі нұсқаулық</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Қауіпсіздікті қамтамасыз ету</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Тәрбиеленушілердің нұсқаулығы</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Балабақша аумағындағы қауіпсіздік</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>
                      Музыка Үйлестірілген оқу іс-әрекеті кезіндегі қауіпсіздік
                    </span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Серуен кезіндегі қауіпсіздік</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Тамақтану кезіндегі қауіпсіздік</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Тәрбиешіге білім беру кезіндегі қауіпсіздік</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Шығармашылық кезіндегі қауіпсіздік</span>
                  </li>
                </ul>
                <p className="font-semibold opacity-80 pt-2">Құжаттар:</p>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Педагогикалық, әдістемелік кеңестің хаттамалары</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Ата-аналар жиналысының хаттамалар</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Жазғы сауықтыру жоспары</span>
                  </li>
                  <li className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-[#f9f2ff] mr-2 flex-shrink-0 mt-0.5" />
                    <span>Семинар/Кеңестер</span>
                  </li>
                </ul>
              </div>
            </div>
            <a
              href="https://wa.me/+77776655965"
              className="bg-[#f9f2ff] cursor-pointer transition hover:bg-[#efe6f6] text-[#674DA2] rounded-full px-6 py-3 mt-8 w-auto lg:w-auto self-start font-semibold"
            >
              Жоспарды таңдау (300 000 ₸)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tarif;
